export default __webpack_public_path__ + "static/media/more-time.3540ac00.svg";